import { render, staticRenderFns } from "./MyGallinasPage.vue?vue&type=template&id=a8997234&scoped=true&"
import script from "./MyGallinasPage.vue?vue&type=script&lang=js&"
export * from "./MyGallinasPage.vue?vue&type=script&lang=js&"
import style0 from "./MyGallinasPage.vue?vue&type=style&index=0&id=a8997234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8997234",
  null
  
)

export default component.exports